import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=1a63832a&scoped=true&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=1a63832a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63832a",
  null
  
)

/* custom blocks */
import block0 from "./ChangePasswordView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports